import React from 'react'
import Generating from '@/images/generating.gif'
function Loader({ className, spinnerClassName, variant }) {
  return (
    <div className={className}>
      { variant === "small" ? (
        <img className={`small-spinner animate-spin ${spinnerClassName}`} src={Generating} alt="Loading icon" loading='eager' ></img>
      ): (
        <img className={`large-spinner animate-spin ${spinnerClassName}`} src={Generating} alt="Loading icon" loading='eager' ></img>
      )}
    </div>
  )
}

export default Loader
